import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import PreconRfqFormReducer from "@preconBlueprint/Store/Pages/Rfq/PreconRfqFormReducer";
import PreconRfqFormState from "@preconBlueprint/Store/Pages/Rfq/PreconRfqFormState";

export type PreconState = {
    preconRfqForm: PreconRfqFormState;
} & ApplicationState;

(reducers as any).preconRfqForm = PreconRfqFormReducer;

type PreconReducers = typeof reducers;

export type PreconActions = AnyAction | Parameters<PreconReducers[keyof PreconReducers]>[1];
